import ProductHero from './ProductHero.jsx';
import BuiltToGrow from './BuiltToGrow.jsx';
import KeyBenefits from './KeyBenefits.jsx';
import IdealFor from './IdealFor.jsx';

/** Alpha ESS SMILE product page. */
export default function AlphaEssSmile() {
  return (
    <>
      <ProductHero />
      <BuiltToGrow />
      <KeyBenefits />
      <hr />
      <IdealFor />
    </>
  );
}
